export const LoanStatuses = {
  PreCredit: 0,
  Credit: 1,
  PreCompliance: 2,
  Compliance: 3,
  PreFundraising: 4,
  Fundraising: 5,
  FullyFilled: 6,
  OnTime: 7,
  Late: 8,
  FullyPaid: 9,
  Default: 10,
  Rejected: 11,
  Expired: 12,
};
